import Search from "./search";
import Filter from "./filter";
import React from "react";

function Home({ darkMode }) {
    return(
        <div id="main" className={darkMode ? "dark-mode" : "light-mode"}>
            
            <div className="body">
                <div className="Search">
                    <Search/>
                </div>
                <div className="Filter">
                    <Filter/>
                </div>

            </div>
        </div>
    )

}
export default Home;